import lpApp from "../../app/lp_app";

class _References {
    constructor(){
        this.initiated = false;
    }

    /**
     * Initiates references
     */
    init(){
        if(this.initiated === true)
            return;

        this.options = lpApp.references.options;
        this.variables = lpApp.references.variables;
        this.sections = lpApp.references.sections;

        // Initiating parents tree
        this.initParentsTree();
        this.initConditionnedOptions();
        this.initMultiplesDependencies();

        this.initiated = true;
    }

    /**
     * Reads Options and Variables wrapper and sets
     * and object with the parents tree of each option
     * and variable
     */
    initParentsTree(){
        let parentsTree = {
            options: {},
            variables: {}
        };

        // Options
        Object.keys(this.options).forEach( (id) => {
            parentsTree.options[id] = [];
            let parent_id = this.getOptionParent( parseInt(id, 10) );
            while(parent_id !== false){
                parentsTree.options[id].push(parent_id);
                parent_id = this.getOptionParent(parent_id);
            }
        });

        // Variables
        Object.keys(this.variables).forEach( (id) => {
            parentsTree.variables[id] = [];
            let parent_id = this.getVariableParent( parseInt(id) );
            while(parent_id !== false){
                parentsTree.variables[id].push(parent_id);
                parent_id = this.getOptionParent(parent_id);
            }
        });

        this.parentsTree = parentsTree;
    }

    /**
     * Reads Options wrapper and sets the list of
     * conditionned options
     */
    initConditionnedOptions(){
        let conditionnedOptions = [];

        // Options
        Object.keys(this.options).forEach( (id) => {
            let option = this.options[id];
            if( option.meta.conditional === true
                && Array.isArray(option.meta.compiledConditions)
                && option.meta.compiledConditions.length > 0){
                    conditionnedOptions.push( parseInt(id, 10) );
            }
        });

        this.conditionnedOptions = conditionnedOptions;
    }

    /**
     * Reads Options wrapper in order to set the deps
     * of multiples
     */
    initMultiplesDependencies(){
        this.multiplesDependencies = {};

        // Options
        Object.keys(this.options).forEach( (id) => {
            let option = this.options[id];


            let repeatOption;
            let multiplesDependencies = [];
            // If it's a repeated option, all it's children must
            // depend on a multiple
            if(option.meta.type === "repeated") {
                repeatOption = option.meta.repeatOption;
                multiplesDependencies = this.getChildrenIds( id );
            }
            // If it's a multiple all it's children depends on it
            else if(option.meta.multiple) {
                repeatOption = id;
                multiplesDependencies = this.getChildrenIds( id );
            }

            // If the array isn't empty we add it to the global object
            if(multiplesDependencies.length > 0){
                if(this.multiplesDependencies.hasOwnProperty(repeatOption)){
                    this.multiplesDependencies[repeatOption] = [...this.multiplesDependencies[repeatOption], ...multiplesDependencies];
                } else {
                    this.multiplesDependencies[repeatOption] = multiplesDependencies;
                }
            }
        });
    }

    /**
     * Returns the full children list of an option
     * @param {integer} id
     */
    getChildrenIds( id ){
        let option = this.options[id];
        let children = [];

        if(Array.isArray(option.children)){
            option.children.forEach((child_id) => {
                children.push( parseInt(child_id, 10) );
                children = [...children, ...this.getChildrenIds(child_id)];
            });
        }

        return children;
    }

    /**
     * @param {number} id Returns the parent's id of the given option's id
     */
    getOptionParent(id){
        let parent = false;
        Object.keys(this.options).forEach( (_id) => {
            let option = this.options[_id];
            if(option.children.includes(id)){
                parent = parseInt(_id, 10);
            }
        });
        return parent;
    }


    /**
     * @param {number} id Returns the parent's id of the given variable's id
     */
    getVariableParent(id){
        let parent = false;
        Object.keys(this.options).forEach( (_id) => {
            let option = this.options[_id];
            if(option.variables.includes(id)){
                parent = parseInt(_id);
            }
        });
        return parent;
    }

    /**
     * Returns parents tree
     */
    getParentsTree(){
        // Initiating refs if they weren't initiated
        if(References.initiated === false)
            References.init();

        return this.parentsTree;
    }

    /**
     * Returns conditionned options list
     */
    getConditionnedOptions(){
        // Initiating refs if they weren't initiated
        if(References.initiated === false)
            References.init();

        return this.conditionnedOptions;
    }

    /**
     * Returns multiples deps list
     */
    getMultiplesDependencies(){
        // Initiating refs if they weren't initiated
        if(References.initiated === false)
            References.init();
        return this.multiplesDependencies;
    }

}

const References = new _References();

export default References;


// WEBPACK FOOTER //
// ./src/logic/jsonlogic/references.js